// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"0ddaa347","390":"6202b58a","416":"aa8c4cbc","916":"6202b58a"}[chunkId] + ".chunk.css";
};